export const validationRules = [
  { text: "指定なし", value: "" },
  { text: "必須", value: "required" },
  { text: "数字のみ", value: "numonly" },
  { text: "英数字のみ", value: "alphanumeric" },
  { text: "メールアドレス", value: "mail" },
  { text: "1以上のみ", value: "OneOrMore" },
  { text: "数値のみ(小数点可)", value: "smallNum" },
  { text: "数値(-.含む)", value: "anyNum" },
  { text: "> X", value: "moreThan" },
  { text: ">=X", value: "orMore" },
  { text: "< X", value: "lessThan" },
  { text: ">=X", value: "orLess" },
  { text: "==X", value: "equal" },
  { text: "!=X", value: "notEqual" },
  { text: "YYYY-MM-DD HH:MM:SS形式", value: "dateTime" },
  { text: "全角のみ", value: "fullWidth" },
  { text: "英数は半角のみ", value: "forcedHalfWidth" },
  { text: "英数は全角のみ", value: "forcedFullWidth" },
];
